import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: null,
  error: "",
  message: "",
};

export const getSingleOfferAction = createAsyncThunk(
  "get-single-offer",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `/admins/api/get/single/offer?offerId=${data.offerId}`
      );
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSingleOfferSlice = createSlice({
  name: "get-single-offer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSingleOfferAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleOfferAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(getSingleOfferAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const getSingleOfferReducer = getSingleOfferSlice.reducer;
